import { Button } from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../components/modal/Dialog";

export const OrderEditItemInsufficientStockModal = ({
  active,
  product,
  onConfirm,
  onDismiss,
  quantity,
}: {
  active: boolean;
  product: {
    id: number;
    name?: string | null;
    availableStock: number;
  };
  onConfirm: () => void;
  onDismiss: () => void;
  quantity: number;
}) => {
  return (
    <Dialog onDismiss={onDismiss} active={active}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={"Add more stock than currently available?"}
        description={``}
      />
      <DialogContent>
        <p className={"text-center"}>
          Only {product.availableStock} of the <b>{product.name}</b> remain in
          stock. Are you sure you want to add {quantity} to this order?
        </p>
      </DialogContent>
      <DialogCTA>
        <Button onClick={onConfirm}>Confirm & add</Button>
      </DialogCTA>
    </Dialog>
  );
};
